import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=deeb2252&scoped=true&"
import script from "./Item.vue?vue&type=script&lang=js&"
export * from "./Item.vue?vue&type=script&lang=js&"
import style0 from "./Item.vue?vue&type=style&index=0&id=deeb2252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deeb2252",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('deeb2252')) {
      api.createRecord('deeb2252', component.options)
    } else {
      api.reload('deeb2252', component.options)
    }
    module.hot.accept("./Item.vue?vue&type=template&id=deeb2252&scoped=true&", function () {
      api.rerender('deeb2252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MobileViews/ValidatePos/Item.vue"
export default component.exports